import React from 'react';
import { StyleSheet, View, useWindowDimensions } from 'react-native';
import { Theme, ThemeConsumer } from '@rneui/themed';
import { ZenIcon, ZenText } from 'zen-core-elements';
import { useAppSelector } from '../../../redux/hooks';
import { formatMinor } from '../discounts/discountLabels';

// Pay X Get Free items: their own lines at no cost and no tax, even when the same product is also bought
const FreeItemLines = () => {
	const { width } = useWindowDimensions()
	const { id: locationId } = useAppSelector((state) => state?.common?.currentLocation)
	const freeLines = useAppSelector((state) => state?.NewSellscreenSlice?.pricedCart?.[locationId]?.freeLines) ?? []
	const currencySymbol = useAppSelector((state) => state?.common?.currentUser?.value?.purchasedCurrency?.currencySymbol) ?? '₹'

	if (!freeLines.length) return null
	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return freeLines.map((line) => (
					<View key={line.key} style={[styles.container, width < 600 && { paddingHorizontal: 0 }]}>
						<View style={styles.card}>
							<View style={styles.accentBar} />
							<View style={styles.content}>
								<View style={{ flex: 1 }}>
									<ZenText content={line.name} style={styles.name} />
									<View style={styles.badge}>
										<ZenIcon type='material-community' name='gift-outline' size={13} color={theme?.tealGreen} />
										<ZenText content={`Free with "${line.title}"`} style={styles.badgeText} />
									</View>
								</View>
								<View style={{ alignItems: 'flex-end' }}>
									<ZenText content={`x${line.quantity}`} style={styles.qty} />
									<ZenText content={formatMinor(currencySymbol, line.originalUnitPrice * line.quantity)} style={styles.strike} />
									<ZenText content="FREE" style={styles.free} />
								</View>
							</View>
						</View>
					</View>
				))
			}}
		</ThemeConsumer>
	)
}

const style = (theme: Theme) => StyleSheet.create({
	container: { paddingHorizontal: 10, marginBottom: 12 },
	card: { flexDirection: 'row', borderRadius: 16, overflow: 'hidden', borderWidth: 1, borderColor: theme?.tealGreen, backgroundColor: theme?.light },
	accentBar: { width: 4, backgroundColor: theme?.tealGreen },
	content: { flex: 1, flexDirection: 'row', paddingHorizontal: 13, paddingVertical: 10, gap: 10 },
	name: { fontSize: theme?.smallerFontSize, fontFamily: theme?.medium, color: theme?.lightDark, marginBottom: 4 },
	badge: { flexDirection: 'row', alignItems: 'center', gap: 4, alignSelf: 'flex-start', backgroundColor: theme?.lightTealGreen, paddingHorizontal: 8, paddingVertical: 3, borderRadius: 6 },
	badgeText: { fontSize: theme?.badgeFontSize, fontFamily: theme?.medium, color: theme?.tealGreen },
	qty: { fontSize: theme?.miniLabel, fontFamily: theme?.medium, color: theme?.grey },
	strike: { fontSize: theme?.badgeFontSize, fontFamily: theme?.medium, color: theme?.grey, textDecorationLine: 'line-through' },
	free: { fontSize: theme?.smallerFontSize, fontFamily: theme?.bold, color: theme?.tealGreen },
})

export default FreeItemLines
